var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6037_27300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5C17.5 6.83696 17.2366 6.20107 16.7678 5.73223C16.2989 5.26339 15.663 5 15 5C14.337 5 13.7011 5.26339 13.2322 5.73223C12.7634 6.20107 12.5 6.83696 12.5 7.5C12.5 8.16304 12.7634 8.79893 13.2322 9.26777C13.7011 9.73661 14.337 10 15 10C15.663 10 16.2989 9.73661 16.7678 9.26777C17.2366 8.79893 17.5 8.16304 17.5 7.5Z",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.5C8.75 21.837 8.48661 21.2011 8.01777 20.7322C7.54893 20.2634 6.91304 20 6.25 20C5.58696 20 4.95107 20.2634 4.48223 20.7322C4.01339 21.2011 3.75 21.837 3.75 22.5C3.75 23.163 4.01339 23.7989 4.48223 24.2678C4.95107 24.7366 5.58696 25 6.25 25C6.91304 25 7.54893 24.7366 8.01777 24.2678C8.48661 23.7989 8.75 23.163 8.75 22.5Z",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.5C26.25 21.837 25.9866 21.2011 25.5178 20.7322C25.0489 20.2634 24.413 20 23.75 20C23.087 20 22.4511 20.2634 21.9822 20.7322C21.5134 21.2011 21.25 21.837 21.25 22.5C21.25 23.163 21.5134 23.7989 21.9822 24.2678C22.4511 24.7366 23.087 25 23.75 25C24.413 25 25.0489 24.7366 25.5178 24.2678C25.9866 23.7989 26.25 23.163 26.25 22.5Z",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 22.5H21.25",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20L16.25 10",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10L7.5 20",
    stroke: "#2177FE",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6037_27300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignBlue);
export default __webpack_public_path__ + "static/media/CampaignBlue.2a702896e4203a210dc85f1066779067.svg";
export { ForwardRef as ReactComponent };